module.exports = __webpack_public_path__ + "static/media/page_not_found.8c4289ea.svg";